import Vue from "vue";
import Router from "vue-router";
import store from "./store/index.js";

Vue.use(Router);


let router = new Router({
  mode: "history",
  base: process.env.BASE_URL,
  routes: [
    {
      path: "/registration",
      name: "register",
      component: () => import("./views/Auth/Register.vue"),
    },
    {
      path: "/api_smsc/v1/registration/confirm/:token",
      name: "registration-confirm",
      component: () => import("./views/Auth/RegistrationConfirm.vue"),
    },
    {
      path: "/forgot-password",
      name: "forgot-password",
      component: () => import("./views/Auth/ForgotPassword.vue"),
    },
    {
      path: "/forgot-password/:token",
      name: "reset-password",
      component: () => import("./views/Auth/ResetPassword.vue"),
    },
    {
      path: "/login",
      name: "login",
      component: () => import("./views/Auth/Login.vue"),
    },
    {
      path: "/",
      // name: "system_admin",
      // component: () => import("./views/SystemAdmin/Dashboard.vue"),
      redirect: { name: 'system_admin' },
      meta: {
        is_system_admin: true,
        requires_auth: true,
        title: "Dashboard",
      },
    },
    {
      path: "/system-admin",
      name: "system_admin",
      component: () => import("./views/SystemAdmin/Dashboard.vue"),
      meta: {
        is_system_admin: true,
        requires_auth: true,
        title: "Dashboard",
      },
    },
    {
      path: "/system-admin/reporting",
      name: "system-admin-reporting",
      redirect: { name: "system-admin-reporting-number" },
      component: () => import("./views/SystemAdmin/Reporting.vue"),
      meta: {
        is_system_admin: true,
        requires_auth: true,
        title: " ",
      },
    },
    {
      path: "/system-admin/reporting/number",
      name: "system-admin-reporting-number",
      component: () => import("./views/SystemAdmin/Report/NumberReport.vue"),
      meta: {
        is_system_admin: true,
        requires_auth: true,
        title: "Number Report",
      },
    },
    {
      path: "/system-admin/reporting/destination",
      name: "system-admin-reporting-destination",
      component: () => import("./views/SystemAdmin/Report/DestinationReport.vue"),
      meta: {
        is_system_admin: true,
        requires_auth: true,
        title: "Destination Report",
      },
    },
    {
      path: "/system-admin/reporting/usage",
      name: "system-admin-reporting-usage",
      component: () => import("./views/SystemAdmin/Report/UsageReport.vue"),
      meta: {
        is_system_admin: true,
        requires_auth: true,
        title: "Usage Report",
      },
    },
    {
      path: "/system-admin/reporting/all-client-vendor",
      name: "system-admin-reporting-all-client-vendor",
      component: () => import("./views/SystemAdmin/Report/AllClientVendorReport.vue"),
      meta: {
        is_system_admin: true,
        requires_auth: true,
        title: "All Client/Vendor Report",
      },
    },
    {
      path: "/system-admin/reporting/specific-clients",
      name: "system-admin-reporting-specific-clients",
      component: () => import("./views/SystemAdmin/Report/SpeceficClientReport.vue"),
      meta: {
        is_system_admin: true,
        requires_auth: true,
        title: "Specific Clients Report",
      },
    },
    {
      path: "/system-admin/reporting/specific-vendors",
      name: "system-admin-reporting-specific-vendors",
      component: () => import("./views/SystemAdmin/Report/SpeceficVendorsReport.vue"),
      meta: {
        is_system_admin: true,
        requires_auth: true,
        title: "Specific Vendors Report",
      },
    },
    {
      path: "/system-admin/reporting/specific-client-vendor",
      name: "system-admin-reporting-specific-client-vendor",
      component: () => import("./views/SystemAdmin/Report/SpeceficClientVendorReport.vue"),
      meta: {
        is_system_admin: true,
        requires_auth: true,
        title: "Specific Client and Vendor Report",
      },
    },
    {
      path: "/system-admin/reporting/expand-into-users",
      name: "system-admin-reporting-expand-into-users",
      component: () => import("./views/SystemAdmin/Report/ExpandUsers.vue"),
      meta: {
        is_system_admin: true,
        requires_auth: true,
        title: "Expand into Users",
      },
    },
    {
      path: "/system-admin/product",
      name: "system-admin-product",
      component: () => import("./views/SystemAdmin/Products/Index.vue"),
      redirect: { name: "system-admin-sms-routes" },
      meta: {
        is_system_admin: true,
        requires_auth: true,
        title: "Products",
      },
      children: [
        {
          path: "sms-routes",
          name: "system-admin-sms-routes",
          component: () =>
            import("./views/SystemAdmin/Products/ProductList.vue"),
          meta: {
            is_system_admin: true,
            requires_auth: true,
            title: "Products",
          },
        },
        {
          path: "sms-pricing",
          name: "system-admin-sms-pricing",
          component: () =>
            import("./views/SystemAdmin/Products/ProductList.vue"),
          meta: {
            is_system_admin: true,
            requires_auth: true,
            title: "Products",
          },
        },
        {
          path: "rate-table",
          name: "system-admin-rate-table",
          component: () => import("./views/SystemAdmin/Products/RateList.vue"),
          meta: {
            is_system_admin: true,
            requires_auth: true,
            title: "Rate Table",
          },
        },
        {
          path: "sms-routes/add-product",
          name: "system-admin-add-route-product",
          component: () =>
            import("./views/SystemAdmin/Products/AddProduct/Index.vue"),
          meta: {
            is_system_admin: true,
            requires_auth: true,
            title: "Add Product",
          },
        },
        {
          path: "sms-routes/edit-product/:id",
          name: "system-admin-edit-route-product",
          component: () =>
            import("./views/SystemAdmin/Products/EditProduct/Index.vue"),
          meta: {
            is_system_admin: true,
            requires_auth: true,
            title: "Edit Product",
          },
        },
        {
          path: "sms-routes/add-company/:id",
          name: "system-admin-add-route-product-company",
          component: () =>
            import("./views/SystemAdmin/Products/AddProductCompany.vue"),
          meta: {
            is_system_admin: true,
            requires_auth: true,
            title: "Add Product Company",
          },
        },
        {
          path: "sms-pricing/add-product",
          name: "system-admin-add-price-product",
          component: () =>
            import("./views/SystemAdmin/Products/AddProduct/AddProduct.vue"),
          meta: {
            is_system_admin: true,
            requires_auth: true,
            title: "",
          },
        },
      ],
    },
    {
      path: '/system-admin/balance-log',
      name: 'system-admin-balance-log',
      component: () => import('./views/SystemAdmin/BalanceLog/Index.vue'),
      redirect: { name: 'system-admin-balance-log-list' },
      meta: {
        is_system_admin: true,
        requires_auth: true,
        title: "Balance Log",
      },
      children: [
        {
          path: 'list',
          name: 'system-admin-balance-log-list',
          component: () => import('./views/SystemAdmin/BalanceLog/BalanceLogList.vue'),
          meta: {
            is_system_admin: true,
            requires_auth: true,
            title: "Balance Log",
          },
        }
      ]
    },
    {
      path: "/system-admin/companies",
      name: "system-admin-companies",
      component: () => import("./views/SystemAdmin/Companies/Index.vue"),
      redirect: { name: "system-admin-company-list" },
      meta: {
        is_system_admin: true,
        requires_auth: true,
        title: "Companies",
      },
      children: [
        {
          path: "company-list",
          name: "system-admin-company-list",
          component: () =>
            import("./views/SystemAdmin/Companies/CompanyList.vue"),
          meta: {
            is_system_admin: true,
            requires_auth: true,
            title: "Companies",
          },
        },
        {
          path: "company-accounts/:id",
          name: "system-admin-company-accounts",
          component: () =>
            import("./views/SystemAdmin/Companies/CompanyAccounts.vue"),
          meta: {
            is_system_admin: true,
            requires_auth: true,
            title: "Company Accounts",
          },
        },
        {
          path: "add-company",
          name: "system-admin-add-company",
          component: () =>
            import("./views/SystemAdmin/Companies/AddCompany.vue"),
          meta: {
            is_system_admin: true,
            requires_auth: true,
            title: "Add Company",
          },
        },
        {
          path: "add-manual-payment",
          name: "system-admin-add-manual-payment",
          component: () =>
            import("./views/SystemAdmin/Companies/AddManualPayment.vue"),
          meta: {
            is_system_admin: true,
            requires_auth: true,
            title: "Add Manual Payment",
          },
        },
        {
          path: "edit-company/:id",
          name: "system-admin-edit-company",
          component: () =>
            import("./views/SystemAdmin/Companies/EditCompany.vue"),
          meta: {
            is_system_admin: true,
            requires_auth: true,
            title: "Edit Company",
          },
        },
        {
          path: ":id/invoice-history/:title",
          name: "system-admin-companies-invoice-history",
          component: () =>
            import("./views/SystemAdmin/Companies/HistoryPages/InvoiceHistory.vue"),
          meta: {
            is_system_admin: true,
            requires_auth: true,
            title: "Company Invoice History",
          },
        },
        {
          path: ":id/payment-history/:title",
          name: "system-admin-companies-payment-history",
          component: () =>
            import("./views/SystemAdmin/Companies/HistoryPages/PaymentHistory.vue"),
          meta: {
            is_system_admin: true,
            requires_auth: true,
            title: "Company Payment History",
          },
        },
        {
          path: "transaction-history/:id",
          name: "system-admin-companies-transaction-history",
          component: () =>
            import("./views/SystemAdmin/Companies/HistoryPages/TransactionHistory.vue"),
          meta: {
            is_system_admin: true,
            requires_auth: true,
            title: "Transaction History",
          },
        },
        {
          path: "add-manual-payment",
          name: "system-admin-companies-add-manual-payment",
          component: () =>
            import("./views/SystemAdmin/Companies/HistoryPages/AddManualPayment.vue"),
          meta: {
            is_system_admin: true,
            requires_auth: true,
            title: "Company Add Manual Payment",
          },
        },
      ],
    },
    {
      path: "/system-admin/resellers",
      name: "system-admin-resellers",
      component: () => import("./views/SystemAdmin/Resellers/Index.vue"),
      redirect: { name: "system-admin-resellers-list" },
      meta: {
        is_system_admin: true,
        requires_auth: true,
        title: "Resellers",
      },
      children: [
        {
          path: "resellers-list",
          name: "system-admin-resellers-list",
          component: () =>
            import("./views/SystemAdmin/Resellers/ResellersList.vue"),
          meta: {
            is_system_admin: true,
            requires_auth: true,
            title: "Resellers",
          },
        },
        {
          path: "reseller/:id",
          name: "system-admin-reseller",
          component: () =>
            import("./views/SystemAdmin/Resellers/Resellers.vue"),
          meta: {
            is_system_admin: true,
            requires_auth: true,
            title: "Reseller Details",
          },
        },
        {
          path: "add-reseller",
          name: "system-admin-add-reseller",
          component: () =>
            import("./views/SystemAdmin/Resellers/AddReseller.vue"),
          meta: {
            is_system_admin: true,
            requires_auth: true,
            title: "Add Reseller",
          },
        },
        {
          path: "add-manual-payment",
          name: "system-admin-add-manual-payment-reseller",
          component: () =>
            import("./views/SystemAdmin/Resellers/AddManualPayment.vue"),
          meta: {
            is_system_admin: true,
            requires_auth: true,
            title: "Add Manual Payment",
          },
        },
        {
          path: "edit-reseller/:id",
          name: "system-admin-edit-reseller",
          component: () =>
            import("./views/SystemAdmin/Resellers/EditReseller.vue"),
          meta: {
            is_system_admin: true,
            requires_auth: true,
            title: "Edit Reseller",
          },
        },
        {
          path: "invoice-history/:id",
          name: "system-admin-resellers-invoice-history",
          component: () =>
            import("./views/SystemAdmin/Resellers/HistoryPages/InvoiceHistory.vue"),
          meta: {
            is_system_admin: true,
            requires_auth: true,
            title: "Reseller Invoice History",
          },
        },
        {
          path: "payment-history/:id",
          name: "system-admin-resellers-payment-history",
          component: () =>
            import("./views/SystemAdmin/Resellers/HistoryPages/PaymentHistory.vue"),
          meta: {
            is_system_admin: true,
            requires_auth: true,
            title: "Reseller Payment History",
          },
        },
        {
          path: "transaction-history:id",
          name: "system-admin-resellers-transaction-history",
          component: () =>
            import("./views/SystemAdmin/Resellers/HistoryPages/TransactionHistory.vue"),
          meta: {
            is_system_admin: true,
            requires_auth: true,
            title: "Reseller Transaction History",
          },
        },
        {
          path: "add-manual-payment",
          name: "system-admin-resellers-add-manual-payment",
          component: () =>
            import("./views/SystemAdmin/Resellers/HistoryPages/AddManualPayment.vue"),
          meta: {
            is_system_admin: true,
            requires_auth: true,
            title: "Reseller Add Manual Payment",
          },
        },
      ],
    },
    {
      path: "/system-admin/users",
      name: "system-admin-users",
      component: () => import("./views/SystemAdmin/Users/Index.vue"),
      redirect: { name: "system-admin-users-list" },
      meta: {
        is_system_admin: true,
        requires_auth: true,
        title: "Users",
      },
      children: [
        {
          path: "",
          name: "system-admin-users-list",
          component: () => import("./views/SystemAdmin/Users/UsersList.vue"),
          meta: {
            is_system_admin: true,
            requires_auth: true,
            title: "Users",
          },
        },
        // {
        //   path: "add",
        //   name: "system-admin-add-user",
        //   component: () => import("./views/SystemAdmin/Users/AddUser.vue"),
        //   meta: {
        //     is_system_admin: true,
        //     requires_auth: true,
        //     title: "Add User",
        //   },
        // },
        {
          path: "edit/:id",
          name: "system-admin-edit-user",
          component: () => import("./views/SystemAdmin/Users/EditUser.vue"),
          meta: {
            is_system_admin: true,
            requires_auth: true,
            title: "Edit User",
          },
        },
        {
          path: "assigned-did/:id",
          name: "system-admin-assigned-did-user",
          component: () =>
            import("./views/SystemAdmin/Users/UserAssignedDid.vue"),
          meta: {
            is_system_admin: true,
            requires_auth: true,
            title: "User Assign DID",
          },
        },
      ],
    },
    {
      path: "/system-admin/template-approval",
      name: "system-admin-template-approval",
      redirect: { name: "system-admin-template-approval-list" },
      component: () => import("./views/SystemAdmin/TemplateApproval/Index.vue"),
      meta: {
        is_system_admin: true,
        requires_auth: true,
        title: "Template Approval",
      },
      children: [
        {
          path: "template-approval-list",
          name: "system-admin-template-approval-list",
          component: () =>
            import("./views/SystemAdmin/TemplateApproval/TemplateApproval.vue"),
          meta: {
            is_system_admin: true,
            requires_auth: true,
            title: "Template Approval",
          },
        },
        {
          path: "add-template",
          name: "system-admin-template-approval-add",
          component: () =>
            import("./views/SystemAdmin/TemplateApproval/AddTemplateApproval.vue"),
          meta: {
            is_system_admin: true,
            requires_auth: true,
            title: "Add Template Approval",
          },
        },
      ],
    },
    {
      path: "/system-admin/billing",
      name: "system-admin-billing",
      redirect: { name: "system-admin-billing-invoices" },
      component: () => import("./views/SystemAdmin/Billing/Index.vue"),
      meta: {
        is_system_admin: true,
        requires_auth: true,
        title: "Invoices",
      },
      children: [
        {
          path: "invoices",
          name: "system-admin-billing-invoices",
          component: () => import("./views/SystemAdmin/Billing/Invoices.vue"),
          meta: {
            is_system_admin: true,
            requires_auth: true,
            title: "Billing",
          },
        },
        {
          path: "add-invoice",
          name: "system-admin-invoice-add",
          component: () => import("./views/SystemAdmin/Billing/AddInvoice.vue"),
          meta: {
            is_system_admin: true,
            requires_auth: true,
            title: "Add Invoice",
          },
        },
        {
          path: "payment",
          name: "system-admin-billing-payment",
          component: () => import("./views/SystemAdmin/Billing/Payment.vue"),
          meta: {
            is_system_admin: true,
            requires_auth: true,
            title: "Billing",
          },
        },
        {
          path: "add-payment",
          name: "system-admin-billing-add-payment",
          component: () => import("./views/SystemAdmin/Billing/AddPayment.vue"),
          meta: {
            is_system_admin: true,
            requires_auth: true,
            title: "Add Payment",
          },
        },
      ],
    },
    {
      path: "/system-admin/dids",
      name: "system-admin-dids",
      redirect: { name: "system-admin-dids-all-dids" },
      component: () => import("./views/SystemAdmin/Dids/Index.vue"),
      meta: {
        is_system_admin: true,
        requires_auth: true,
        title: "DIDs",
      },
      children: [
        {
          path: "all-dids",
          name: "system-admin-dids-all-dids",
          component: () => import("./views/SystemAdmin/Dids/AllDids.vue"),
          meta: {
            is_system_admin: true,
            requires_auth: true,
            title: "DIDs",
          },
        },
        {
          path: "add-did",
          name: "system-admin-dids-add-did",
          component: () => import("./views/SystemAdmin/Dids/AddDid.vue"),
          meta: {
            is_system_admin: true,
            requires_auth: true,
            title: "Add DID",
          },
        },
        {
          path: "import-log",
          name: "system-admin-dids-import-log",
          component: () => import("./views/SystemAdmin/Dids/ImportLogList.vue"),
          meta: {
            is_system_admin: true,
            requires_auth: true,
            title: "Import Log",
          },
        },
        {
          path: "import-did",
          name: "system-admin-dids-import-did",
          component: () => import("./views/SystemAdmin/Dids/ImportDid.vue"),
          meta: {
            is_system_admin: true,
            requires_auth: true,
            title: "Import DID",
          },
        },
        {
          path: "edit-did/:id",
          name: "system-admin-dids-edit-did",
          component: () => import("./views/SystemAdmin/Dids/EditDid.vue"),
          meta: {
            is_system_admin: true,
            requires_auth: true,
            title: "Edit DID",
          },
        },
        {
          path: "all-suppressions",
          name: "system-admin-dids-all-suppressions",
          component: () =>
            import("./views/SystemAdmin/Dids/AllSuppressions.vue"),
          meta: {
            is_system_admin: true,
            requires_auth: true,
            title: "Suppressions",
          },
        },
        {
          path: "add-suppression",
          name: "system-admin-dids-add-suppression",
          component: () =>
            import("./views/SystemAdmin/Dids/AddSuppression.vue"),
          meta: {
            is_system_admin: true,
            requires_auth: true,
            title: "Add Suppression",
          },
        },
        {
          path: "new-call-flow",
          name: "system-admin-dids-new-call-flow",
          component: () => import("./views/SystemAdmin/Dids/NewCallFlow.vue"),
          meta: {
            is_system_admin: true,
            requires_auth: true,
            title: "CallFlow",
          },
        },
      ],
    },
    {
      path: "/system-admin/vendor",
      name: "system-admin-vendor",
      redirect: { name: "system-admin-vendor-list" },
      component: () => import("./views/SystemAdmin/Vendors/Index.vue"),
      meta: {
        is_system_admin: true,
        requires_auth: true,
        title: "Vendors",
      },
      children: [
        {
          path: "vendors",
          name: "system-admin-vendor-list",
          component: () => import("./views/SystemAdmin/Vendors/VendorList.vue"),
          meta: {
            is_system_admin: true,
            requires_auth: true,
            title: "Vendors",
          },
        },
        {
          path: "list/:vendor_name/:vendor_uuid",
          name: "system-admin-vendor-accounts-list",
          component: () =>
            import("./views/SystemAdmin/Vendors/VendorProducts/Accounts.vue"),
          meta: {
            is_system_admin: true,
            requires_auth: true,
            title: "SMSC Connection",
          },
        },
        {
          path: "add-vendor",
          name: "system-admin-vendor-add",
          component: () => import("./views/SystemAdmin/Vendors/AddVendor.vue"),
          meta: {
            is_system_admin: true,
            requires_auth: true,
            title: "Add Vendor",
          },
        },
        {
          path: "edit-vendor/:id",
          name: "system-admin-vendor-edit",
          component: () => import("./views/SystemAdmin/Vendors/EditVendor.vue"),
          meta: {
            is_system_admin: true,
            requires_auth: true,
            title: "Edit Vendor",
          },
        },
        {
          path: ":id/rate-deck",
          name: "system-admin-vendor-rate-deck",
          component: () => import("./views/SystemAdmin/Vendors/RateDeck.vue"),
          meta: {
            is_system_admin: true,
            requires_auth: true,
            title: "Rate Deck",
          },
        },
        {
          path: ":id/add/rate-deck",
          name: "system-admin-vendor-add-rate-deck",
          component: () =>
            import("./views/SystemAdmin/Vendors/AddVendorRate.vue"),
          meta: {
            is_system_admin: true,
            requires_auth: true,
            title: "Add Vendor Rate",
          },
        },
        {
          path: "did/:id/:vendor_name",
          name: "system-admin-vendor-did",
          component: () =>
            import("./views/SystemAdmin/Vendors/VendorDids/VendorDidsList.vue"),
          meta: {
            is_system_admin: true,
            requires_auth: true,
            title: null,
          },
        },
        {
          path: "did/:id/edit",
          name: "system-admin-vendor-did-edit",
          component: () =>
            import("./views/SystemAdmin/Vendors/VendorDids/EditVendorDid.vue"),
          meta: {
            is_system_admin: true,
            requires_auth: true,
            title: 'Edit',
          },
        },
        {
          path: "accounts/:id",
          name: "system-admin-vendor-accounts",
          redirect: { name: "system-admin-vendor-accounts-list" },
          component: () =>
            import("./views/SystemAdmin/Vendors/VendorProducts/Index.vue"),
          meta: {
            is_system_admin: true,
            requires_auth: true,
            title: "Vendor Products",
          },
        },
        // children: [
        {
          path: "add-vendor-product",
          name: "system-admin-vendor-product-add",
          component: () =>
            import("./views/SystemAdmin/Vendors/VendorProducts/AddVendorProduct.vue"),
          meta: {
            is_system_admin: true,
            requires_auth: true,
            title: "Add Vendor Product",
          },
        },
        {
          path: "edit-vendor-product/:vendor_product_id",
          name: "system-admin-vendor-product-edit",
          component: () =>
            import("./views/SystemAdmin/Vendors/VendorProducts/EditVendorProduct.vue"),
          meta: {
            is_system_admin: true,
            requires_auth: true,
            title: "Edit Vendor Product",
          },
        },
        // ],
        // },
      ],
    },
    {
      path: "/system-admin/smsc-connection",
      name: "system-admin-smsc-connection",
      redirect: { name: "system-admin-smsc-connection-list" },
      component: () => import("./views/SystemAdmin/SmscConnection/Index.vue"),
      meta: {
        is_system_admin: true,
        requires_auth: true,
        title: "SMSC Connection",
      },
      children: [
        {
          path: "smsc-connection/list",
          name: "system-admin-smsc-connection-list",
          component: () =>
            import("./views/SystemAdmin/SmscConnection/SmscConnectionList.vue"),
          meta: {
            is_system_admin: true,
            requires_auth: true,
            title: "SMSC Connection",
          },
        },
        {
          path: "add-smsc-connection",
          name: "system-admin-smsc-connection-add",
          component: () =>
            import("./views/SystemAdmin/SmscConnection/AddSmscConnection.vue"),
          meta: {
            is_system_admin: true,
            requires_auth: true,
            title: "Add SMSC Connection",
          },
        },
        {
          path: "edit-smsc-connection/:id",
          name: "system-admin-smsc-connection-edit",
          component: () =>
            import("./views/SystemAdmin/SmscConnection/EditSmscConnection.vue"),
          meta: {
            is_system_admin: true,
            requires_auth: true,
            title: "Edit SMSC Connection",
          },
        },
      ],
    },
    {
      path: "/system-admin/filters",
      name: "system-admin-filters",
      redirect: { name: "system-admin-filter-list" },
      component: () => import("./views/SystemAdmin/Filters/Index.vue"),
      meta: {
        is_system_admin: true,
        requires_auth: true,
        title: "Filters",
      },
      children: [
        {
          path: "filter-list",
          name: "system-admin-filter-list",
          component: () => import("./views/SystemAdmin/Filters/FilterList.vue"),
          meta: {
            is_system_admin: true,
            requires_auth: true,
            title: "Filters",
          },
        },
        {
          path: "add-filter",
          name: "system-admin-filter-add",
          component: () => import("./views/SystemAdmin/Filters/AddFilter.vue"),
          meta: {
            is_system_admin: true,
            requires_auth: true,
            title: "Add Filter",
          },
        },
        {
          path: "edit-filter/:id",
          name: "system-admin-filter-edit",
          component: () => import("./views/SystemAdmin/Filters/EditFilter.vue"),
          meta: {
            is_system_admin: true,
            requires_auth: true,
            title: "Edit Filter",
          },
        },
      ],
    },
    {
      path: "/system-admin/payment-term",
      name: "system-admin-payment-term",
      redirect: { name: "system-admin-payment-term-list" },
      component: () => import("./views/SystemAdmin/PaymentTerm/Index.vue"),
      meta: {
        is_system_admin: true,
        requires_auth: true,
        title: "Payment Term",
      },
      children: [
        {
          path: "list",
          name: "system-admin-payment-term-list",
          component: () =>
            import("./views/SystemAdmin/PaymentTerm/PaymentTerm.vue"),
          meta: {
            is_system_admin: true,
            requires_auth: true,
            title: "Payment Term",
          },
        },
        {
          path: "add",
          name: "system-admin-add-payment-term",
          component: () =>
            import("./views/SystemAdmin/PaymentTerm/AddPaymenTerm.vue"),
          meta: {
            is_system_admin: true,
            requires_auth: true,
            title: "Add Payment Term",
          },
        },
        {
          path: "edit/:id",
          name: "system-admin-edit-payment-term",
          component: () =>
            import("./views/SystemAdmin/PaymentTerm/EditPaymentTerm.vue"),
          meta: {
            is_system_admin: true,
            requires_auth: true,
            title: "Edit Payment Term",
          },
        },
        {
          path: ":id/companies",
          name: "system-admin-payment-term-companies",
          component: () =>
            import("./views/SystemAdmin/PaymentTerm/PaymentTermCompanies.vue"),
          meta: {
            is_system_admin: true,
            requires_auth: true,
            title: "Payment Term Companies",
          },
        },
      ],
    },
    {
      path: "/system-admin/sms-log",
      name: "system-admin-sms-log",
      redirect: { name: "system-admin-sms-log-list-incoming" },
      component: () => import("./views/SystemAdmin/SmsLog/Index.vue"),
      meta: {
        is_system_admin: true,
        requires_auth: true,
        title: "SMS Log",
      },
      children: [
        {
          path: "incoming",
          name: "system-admin-sms-log-list-incoming",
          component: () => import("./views/SystemAdmin/SmsLog/Incoming.vue"),
          meta: {
            is_system_admin: true,
            requires_auth: true,
            title: "SMS Log",
          },
        },
        {
          path: "outgoing",
          name: "system-admin-sms-log-list-outgoing",
          component: () => import("./views/SystemAdmin/SmsLog/Outgoing.vue"),
          meta: {
            is_system_admin: true,
            requires_auth: true,
            title: "SMS Log",
          },
        },
      ],
    },
    {
      path: '/system-admin/ani-group',
      name: 'system-admin-ani-group',
      redirect: { name: 'system-admin-ani-group-list' },
      component: () => import('./views/SystemAdmin/AniGroup/Index.vue'),
      meta: {
        is_system_admin: true,
        requires_auth: true,
        title: "ANI Group",
      },
      children: [
        {
          path: 'list',
          name: 'system-admin-ani-group-list',
          component: () => import('./views/SystemAdmin/AniGroup/AniGroupList.vue'),
          meta: {
            is_system_admin: true,
            requires_auth: true,
            title: "ANI Group",
          },
        },
        {
          path: 'import',
          name: 'system-admin-ani-group-import',
          component: () => import('./views/SystemAdmin/AniGroup/Import.vue'),
          meta: {
            is_system_admin: true,
            requires_auth: true,
            title: "Import Number",
          },
        },
        {
          path: 'numbers/:uuid',
          name: 'system-admin-ani-group-numbers',
          component: () => import('./views/SystemAdmin/AniGroup/AniNumbers.vue'),
          props: true,
          meta: {
            is_system_admin: true,
            requires_auth: true,
            title: "ANI Numbers",
          },
        },
      ]
    },
    {
      path: "/system-admin/bulk",
      name: "system-admin-bulk",
      component: () => import("./views/CompanyAdmin/Bulk/index.vue"),
      redirect: { name: "system-admin-bulk-report" },
      meta: {
        is_system_admin: true,
        requires_auth: true,
        title: "Bulk Report",
      },
      children: [
        {
          path: "",
          name: "system-admin-bulk-report",
          component: () =>
            import("./views/CompanyAdmin/Bulk/BulkReport.vue"),
          meta: {
            is_system_admin: true,
            requires_auth: true,
            title: "Bulk Report",
          },
        },
      ],
    },
    {
      path: "/system-admin/admin-user-management",
      name: "admin-user-management",
      component: () => import("./views/SystemAdmin/AdminUserManagement/index.vue"),
      redirect: { name: "system-admin-admin-list" },
      meta: {
        is_system_admin: true,
        requires_auth: true,
        title: "Admin User Management",
      },
      children: [
        {
          path: "/system-admin/admins",
          name: "system-admin-admin-list",
          component: () =>
            import("./views/SystemAdmin/AdminUserManagement/AdminList.vue"),
          meta: {
            is_system_admin: true,
            requires_auth: true,
            title: "Admin User Management",
          },
        },
        {
          path: "/system-admin/admins/add-admin",
          name: "system-admin-add-admin",
          component: () =>
            import("./views/SystemAdmin/AdminUserManagement/AddAdmin.vue"),
          meta: {
            is_system_admin: true,
            requires_auth: true,
            title: "Add Admin",
          },
        },
        {
          path: "/system-admin/admins/edit/:id",
          name: "system-admin-edit-admin",
          component: () =>
            import("./views/SystemAdmin/AdminUserManagement/EditAdmin.vue"),
          meta: {
            is_system_admin: true,
            requires_auth: true,
            title: "Edit Admin",
          },
        },

      ],
    },
    {
      path: "/system-admin/profile",
      name: "system-admin-profile",
      redirect: { name: "system-admin-admin-info" },
      component: () => import("./views/SystemAdmin/Profile/index.vue"),
      meta: {
        is_system_admin: true,
        requires_auth: true,
        title: "Profile",
      },
      children: [
        {
          path: "system-info",
          name: "system-admin-admin-info",
          component: () =>
            import("./views/SystemAdmin/Profile/AdminInfo.vue"),
          meta: {
            is_system_admin: true,
            requires_auth: true,
            title: "Admin Info",
          },
        },
        {
          path: "edit-admin-info/:id",
          name: "system-admin-info-edit",
          component: () =>
            import("./views/SystemAdmin/Profile/EditAdminInfo.vue"),
          meta: {
            is_system_admin: true,
            requires_auth: true,
            title: "Edit Profile",
          },
        },
      ],
    },


    {
      path: "/company-admin/profile",
      name: "company-admin-profile",
      redirect: { name: "company-admin-company-info" },
      component: () => import("./views/CompanyAdmin/Profile/Index.vue"),
      meta: {
        is_company_admin: true,
        requires_auth: true,
        title: "Profile",
      },
      children: [
        {
          path: "company-info",
          name: "company-admin-company-info",
          component: () =>
            import("./views/CompanyAdmin/Profile/CompanyInfo.vue"),
          meta: {
            is_company_admin: true,
            requires_auth: true,
            title: "Company Info",
          },
        },
        {
          path: "edit-company-info/:id",
          name: "company-admin-company-info-edit",
          component: () =>
            import("./views/CompanyAdmin/Profile/EditCompanyInfo.vue"),
          meta: {
            is_company_admin: true,
            requires_auth: true,
            title: "Edit Company Info",
          },
        },
        {
          path: "admin-contact",
          name: "company-admin-admin-contact",
          component: () =>
            import("./views/CompanyAdmin/Profile/AdminContact.vue"),
          meta: {
            is_company_admin: true,
            requires_auth: true,
            title: "Admin Contact",
          },
        },
      ],
    },
      {
      path: "/company-admin/payment-success",
      name: "company-admin-payment-success",
      component: () =>
        import("./views/CompanyAdmin/PaymentGateway/PaymentSuccess.vue"),
      meta: {
        is_company_admin: true,
        requires_auth: true,
        title: "Payment Success",
      },
    },
    {
      path: "/company-admin/payment-cancel",
      name: "company-admin-payment-cancel",
      component: () =>
        import("./views/CompanyAdmin/PaymentGateway/PaymentCancel.vue"),
      meta: {
        is_company_admin: true,
        requires_auth: true,
        title: "Payment Success",
      },
    },
    {
      path: "/company-admin/payment-success",
      name: "company-admin-payment-success",
      component: () =>
        import("./views/CompanyAdmin/PaymentGateway/PaymentSuccess.vue"),
      meta: {
        is_company_admin: true,
        requires_auth: true,
        title: "Payment Success",
      },
    },
    {
      path: "/company-admin/payment-cancel",
      name: "company-admin-payment-cancel",
      component: () =>
        import("./views/CompanyAdmin/PaymentGateway/PaymentCancel.vue"),
      meta: {
        is_company_admin: true,
        requires_auth: true,
        title: "Payment Success",
      },
    },
    {
      path: "/company-admin",
      name: "company_admin",
      redirect: { name: "company-admin-daily-usage" },
      component: () => import("./views/CompanyAdmin/Alert/Index.vue"),
      meta: {
        is_company_admin: true,
        requires_auth: true,
        title: "Dashboard",
      },
      children: [
        {
          path: "dashboard",
          name: "company-admin-dashboard",
          component: () => import("./views/CompanyAdmin/Alert/Dashboard.vue"),
          meta: {
            is_company_admin: true,
            requires_auth: true,
            title: "Dashboard",
          },
        },
        {
          path: "daily-usage",
          name: "company-admin-daily-usage",
          component: () => import("./views/CompanyAdmin/Alert/DailyUsage.vue"),
          meta: {
            is_company_admin: true,
            requires_auth: true,
            title: "Dashboard Daily Usage",
          },
        },
        {
          path: "weekly-usage",
          name: "company-admin-weekly-usage",
          component: () => import("./views/CompanyAdmin/Alert/WeeklyUsage.vue"),
          meta: {
            is_company_admin: true,
            requires_auth: true,
            title: "Dashboard Weekly Usage",
          },
        },
      ],
    },

    {
      path: "/company-admin/sms-center",
      name: "company-admin-sms-center",
      component: () => import("./views/CompanyAdmin/SmsCenter/Index.vue"),
      meta: {
        is_company_admin: true,
        requires_auth: true,
        title: "Sms Center",
      },
    },
    {
      path: "/company-admin/bulk-sending",
      name: "company-admin-bulk-sending",
      component: () => import("./views/CompanyAdmin/BulkSending/Index.vue"),
      redirect: { name: "company-admin-bulk-sending-send" },
      meta: {
        is_company_admin: true,
        requires_auth: true,
        title: "Bulk Sending",
      },
      children: [
        {
          path: "",
          name: "company-admin-bulk-sending-send",
          component: () =>
            import("./views/CompanyAdmin/BulkSending/SendBulk.vue"),
          meta: {
            is_company_admin: true,
            requires_auth: true,
            title: "Send Bulk",
          },
        },
        {
          path: "history",
          name: "company-admin-bulk-sending-history",
          component: () =>
            import("./views/CompanyAdmin/BulkSending/History.vue"),
          meta: {
            is_company_admin: true,
            requires_auth: true,
            title: "History",
          },
        },
      ],
    },
    {
      path: "/company-admin/payment-gateway",
      name: "company-admin-payment-gateway",
      component: () =>
        import("./views/CompanyAdmin/PaymentGateway/PaymentGateway.vue"),
      meta: {
        is_company_admin: true,
        requires_auth: true,
        title: "Payment Gateway",
      },
    },
   
    {
      path: "/company-admin/users",
      name: "company-admin-users",
      component: () => import("./views/CompanyAdmin/Users/Index.vue"),
      redirect: { name: "company-admin-users-list" },
      meta: {
        is_company_admin: true,
        requires_auth: true,
        title: "Users",
      },
      children: [
        {
          path: "",
          name: "company-admin-users-list",
          component: () => import("./views/CompanyAdmin/Users/UsersList.vue"),
          meta: {
            is_company_admin: true,
            requires_auth: true,
            title: "Users",
          },
        },
        {
          path: "add",
          name: "company-admin-add-user",
          component: () => import("./views/CompanyAdmin/Users/AddUser.vue"),
          meta: {
            is_company_admin: true,
            requires_auth: true,
            title: "Add User",
          },
        },
        {
          path: "edit/:id",
          name: "company-admin-edit-user",
          component: () => import("./views/CompanyAdmin/Users/EditUser.vue"),
          meta: {
            is_company_admin: true,
            requires_auth: true,
            title: "Edit User",
          },
        },
        {
          path: "assigned-did/:id",
          name: "company-admin-assigned-did-user",
          component: () =>
            import("./views/CompanyAdmin/Users/UserAssignedDid.vue"),
          meta: {
            is_company_admin: true,
            requires_auth: true,
            title: "User Assigned DIDs",
          },
        },
      ],
    },
    {
      path: "/company-admin/templates",
      name: "company-admin-templates",
      component: () => import("./views/CompanyAdmin/Templates/Index.vue"),
      redirect: { name: "company-admin-templates-list" },
      meta: {
        is_company_admin: true,
        requires_auth: true,
        title: "Templates",
      },
      children: [
        {
          path: "",
          name: "company-admin-templates-list",
          component: () =>
            import("./views/CompanyAdmin/Templates/TemplatesList.vue"),
          meta: {
            is_company_admin: true,
            requires_auth: true,
            title: "Templates",
          },
        },
        {
          path: "add",
          name: "company-admin-add-template",
          component: () =>
            import("./views/CompanyAdmin/Templates/AddTemplate.vue"),
          meta: {
            is_company_admin: true,
            requires_auth: true,
            title: "Add Template",
          },
        },
        {
          path: "edit/:id",
          name: "company-admin-edit-template",
          component: () =>
            import("./views/CompanyAdmin/Templates/EditTemplate.vue"),
          meta: {
            is_company_admin: true,
            requires_auth: true,
            title: "Edit Template",
          },
        },
      ],
    },
    {
      path: "/company-admin/sms-workflow",
      name: "company-admin-sms-workflow",
      component: () => import("./views/CompanyAdmin/SmsWorkflow/Index.vue"),
      redirect: { name: "company-admin-sms-workflow-list" },
      meta: {
        is_company_admin: true,
        requires_auth: true,
        title: "Sms Workflow",
      },
      children: [
        {
          path: "",
          name: "company-admin-sms-workflow-list",
          component: () =>
            import("./views/CompanyAdmin/SmsWorkflow/SmsWorkflowList.vue"),
          meta: {
            is_company_admin: true,
            requires_auth: true,
            title: "Sms Workflow",
          },
        },
        {
          path: "add",
          name: "company-admin-add-workflow",
          component: () =>
            import("./views/CompanyAdmin/SmsWorkflow/AddWorkflow.vue"),
          meta: {
            is_company_admin: true,
            requires_auth: true,
            title: "Add Sms Workflow",
          },
        },
        {
          path: "edit/:id",
          name: "company-admin-edit-workflow",
          component: () =>
            import("./views/CompanyAdmin/SmsWorkflow/EditWorkflow.vue"),
          meta: {
            is_company_admin: true,
            requires_auth: true,
            title: "Edit Sms Workflow",
          },
        },
      ],
    },
    {
      path: "/company-admin/reporting",
      name: "company-admin-reporting",
      redirect: { name: 'company-admin-reporting-number' },
      component: () => import("./views/CompanyAdmin/Reporting.vue"),
      meta: {
        is_company_admin: true,
        requires_auth: true,
        title: " ",
      },
    },
    {
      path: "/company-admin/reporting/number",
      name: "company-admin-reporting-number",
      component: () => import("./views/CompanyAdmin/Report/NumberReport.vue"),
      meta: {
        is_company_admin: true,
        requires_auth: true,
        title: "Number Report",
      },
    },
    {
      path: "/company-admin/reporting/destination",
      name: "company-admin-reporting-destination",
      component: () => import("./views/CompanyAdmin/Report/DestinationReport.vue"),
      meta: {
        is_company_admin: true,
        requires_auth: true,
        title: "Destination Report",
      },
    },
    {
      path: "/company-admin/reporting/usage-report",
      name: "company-admin-reporting-usage-report",
      component: () => import("./views/CompanyAdmin/Report/UsageReport.vue"),
      meta: {
        is_company_admin: true,
        requires_auth: true,
        title: "Usage Report",
      },
    },
    {
      path: "/company-admin/reminder-workflow",
      name: "company-admin-reminder-workflow",
      component: () =>
        import("./views/CompanyAdmin/ReminderWorkflow/Index.vue"),
      redirect: { name: "company-admin-reminder-workflow-list" },
      meta: {
        is_company_admin: true,
        requires_auth: true,
        title: "Reminder Workflow",
      },
      children: [
        {
          path: "",
          name: "company-admin-reminder-workflow-list",
          component: () =>
            import("./views/CompanyAdmin/ReminderWorkflow/ReminderWorkflowList.vue"),
          meta: {
            is_company_admin: true,
            requires_auth: true,
            title: "Reminder Workflow",
          },
        },
        {
          path: "add",
          name: "company-admin-add-reminder-workflow",
          component: () =>
            import("./views/CompanyAdmin/ReminderWorkflow/AddReminderWorkflow.vue"),
          meta: {
            is_company_admin: true,
            requires_auth: true,
            title: "Add reminder Workflow",
          },
        },
        {
          path: "edit/:id",
          name: "company-admin-edit-reminder-workflow",
          component: () =>
            import("./views/CompanyAdmin/ReminderWorkflow/EditReminderWorkflow.vue"),
          meta: {
            is_company_admin: true,
            requires_auth: true,
            title: "Edit Reminder Workflow",
          },
        },
      ],
    },
    {
      path: "/company-admin/recipients",
      name: "company-admin-recipients",
      component: () => import("./views/CompanyAdmin/Recipients/index.vue"),
      redirect: { name: "company-admin-recipients-list" },
      meta: {
        is_company_admin: true,
        requires_auth: true,
        title: "Recipients",
      },
      children: [
        {
          path: "",
          name: "company-admin-recipients-list",
          component: () =>
            import("./views/CompanyAdmin/Recipients/RecipientList.vue"),
          meta: {
            is_company_admin: true,
            requires_auth: true,
            title: "Recipients",
          },
        },
        {
          path: "add",
          name: "company-admin-add-recipient",
          component: () =>
            import("./views/CompanyAdmin/Recipients/AddRecipient.vue"),
          meta: {
            is_company_admin: true,
            requires_auth: true,
            title: "Add Recipient",
          },
        },
        {
          path: "edit/:id",
          name: "company-admin-edit-recipient",
          component: () =>
            import("./views/CompanyAdmin/Recipients/EditRecipient.vue"),
          meta: {
            is_company_admin: true,
            requires_auth: true,
            title: "Edit Recipient",
          },
        },
        {
          path: "import",
          name: "company-admin-import-recipient",
          component: () =>
            import("./views/CompanyAdmin/Recipients/ImportRecipient.vue"),
          meta: {
            is_company_admin: true,
            requires_auth: true,
            title: "Import Recipient",
          },
        },
      ],
    },
    // {
    //   path: "/company-admin/webhook",
    //   name: "company-admin-webhook",
    //   component: () => import("./views/CompanyAdmin/Webhook/index.vue"),
    //   redirect: { name: "company-admin-webhook-list" },
    //   meta: {
    //     is_company_admin: true,
    //     requires_auth: true,
    //     title: "Webhook",
    //   },
    //   children: [
    //     {
    //       path: "",
    //       name: "company-admin-webhook-list",
    //       component: () =>
    //         import("./views/CompanyAdmin/Webhook/WebhookList.vue"),
    //       meta: {
    //         is_company_admin: true,
    //         requires_auth: true,
    //         title: "Webhooks",
    //       },
    //     },
    //     {
    //       path: "add",
    //       name: "company-admin-add-webhook",
    //       component: () =>
    //         import("./views/CompanyAdmin/Webhook/AddWebhook.vue"),
    //       meta: {
    //         is_company_admin: true,
    //         requires_auth: true,
    //         title: "Add Webhook",
    //       },
    //     },
    //     {
    //       path: "edit/:id",
    //       name: "company-admin-edit-webhook",
    //       component: () =>
    //         import("./views/CompanyAdmin/Webhook/EditWebhook.vue"),
    //       meta: {
    //         is_company_admin: true,
    //         requires_auth: true,
    //         title: "Edit Webhook",
    //       },
    //     },
    //   ],
    // },

    {
      path: "/company-admin/bulk",
      name: "company-admin-bulk",
      component: () => import("./views/CompanyAdmin/Bulk/index.vue"),
      redirect: { name: "company-admin-bulk-report" },
      meta: {
        is_company_admin: true,
        requires_auth: true,
        title: "Bulk Report",
      },
      // children: [
      //   {
      //     path: "",
      //     name: "company-admin-bulk-report",
      //     component: () =>
      //       import("./views/CompanyAdmin/Bulk/BulkReport.vue"),
      //     meta: {
      //       is_company_admin: true,
      //       requires_auth: true,
      //       title: "Bulk Report",
      //     },
      //   },
      // ],
    },

    {
      path: "/company-admin/bulk/bulk-report",
      name: "company-admin-bulk-report",
      component: () =>
          import("./views/CompanyAdmin/Bulk/BulkReport.vue"),
      meta: {
        is_company_admin: true,
        requires_auth: true,
        title: "Bulk Report",
      },
    },

    {
      path: "/company-admin/bulk/auto-substitute",
      name: "company-admin-bulk-auto-substitute-report",
      component: () =>
          import("./views/CompanyAdmin/Bulk/AutoSubstitutingReport.vue"),
      meta: {
        is_company_admin: true,
        requires_auth: true,
        title: "Auto Substituting Report",
      },
    },
    {
      path: "/system-admin/bulk/auto-substitute",
      name: "system-admin-bulk-auto-substitute-report",
      component: () =>
          import("./views/CompanyAdmin/Bulk/systemAutoSubstitutingReport.vue"),
      meta: {
        is_system_admin: true,
        requires_auth: true,
        title: "Auto Substituting Report",
      },
    },
    {
      path: "/company-admin/bulk/bulk-sms",
      name: "company-admin-bulk-sms",
      component: () =>
          import("./views/CompanyAdmin/Bulk/BulkSms.vue"),
      meta: {
        is_company_admin: true,
        requires_auth: true,
        title: "Bulk Sms",
      },
    },
    {
      path: "/system-admin/bulk/bulk-sms",
      name: "system-admin-bulk-sms",
      component: () =>
          import("./views/CompanyAdmin/Bulk/systemBulkSms.vue"),
      meta: {
        is_system_admin: true,
        requires_auth: true,
        title: "Bulk Sms",
      },
    },
    {
      path: "/company-admin/campaings",
      name: "company-admin-campaings",
      redirect: { name: "company-admin-campaings-all-campaings" },
      component: () => import("./views/CompanyAdmin/Campaings/Index.vue"),
      meta: {
        is_company_admin: true,
        requires_auth: true,
        title: "Campaings",
      },
      children: [
        {
          path: "dashboard",
          name: "company-admin-campaings-dashboard",
          component: () =>
            import("./views/CompanyAdmin/Campaings/Dashboard.vue"),
          meta: {
            is_company_admin: true,
            requires_auth: true,
            title: "Campaings Dashboard",
          },
        },
        {
          path: "all-campaings",
          name: "company-admin-campaings-all-campaings",
          component: () =>
            import("./views/CompanyAdmin/Campaings/AllCampaigns.vue"),
          meta: {
            is_company_admin: true,
            requires_auth: true,
            title: "Campaings",
          },
        },
        {
          path: "keyword-manager",
          name: "company-admin-campaings-keyword-manager",
          component: () =>
            import("./views/CompanyAdmin/Campaings/KeywordManager.vue"),
          meta: {
            is_company_admin: true,
            requires_auth: true,
            title: "Keyword Manager",
          },
        },
        {
          path: "ani-group",
          name: "company-admin-campaings-ani-groups",
          component: () =>
            import("./views/CompanyAdmin/Campaings/AniGroupList.vue"),
          meta: {
            is_company_admin: true,
            requires_auth: true,
            title: "Ani Groups",
          },
        },
        {
          path: "add-ani-group",
          name: "company-admin-campaings-add-ani-group",
          component: () =>
            import("./views/CompanyAdmin/Campaings/AddAniGroup.vue"),
          meta: {
            is_company_admin: true,
            requires_auth: true,
            title: "Add Ani Groups",
          },
        },
        {
          path: "edit-ani-group/:id",
          name: "company-admin-campaings-edit-ani-group",
          component: () =>
            import("./views/CompanyAdmin/Campaings/EditAniGroup.vue"),
          meta: {
            is_company_admin: true,
            requires_auth: true,
            title: "Edit Ani Groups",
          },
        },
        {
          path: "import-ani-group",
          name: "company-admin-campaings-import-ani-group",
          component: () =>
            import("./views/CompanyAdmin/Campaings/ImportAni.vue"),
          meta: {
            is_company_admin: true,
            requires_auth: true,
            title: "Import Ani",
          },
        },
        {
          path: "add-keyword",
          name: "company-admin-campaings-add-keyword",
          component: () =>
            import("./views/CompanyAdmin/Campaings/AddKeyword.vue"),
          meta: {
            is_company_admin: true,
            requires_auth: true,
            title: "Add Keyword",
          },
        },
        {
          path: "edit-keyword/:id",
          name: "company-admin-campaings-edit-keyword",
          component: () =>
            import("./views/CompanyAdmin/Campaings/EditKeyword.vue"),
          meta: {
            is_company_admin: true,
            requires_auth: true,
            title: "Edit Keyword",
          },
        },
        {
          path: "add-campaing",
          name: "company-admin-campaings-add-campaing",
          component: () =>
            import("./views/CompanyAdmin/Campaings/AddCampaign.vue"),
          meta: {
            is_company_admin: true,
            requires_auth: true,
            title: "Add Campaign",
          },
        },
        {
          path: "edit-campaing/:id",
          name: "company-admin-campaings-edit-campaing",
          component: () =>
            import("./views/CompanyAdmin/Campaings/EditCampaign.vue"),
          meta: {
            is_company_admin: true,
            requires_auth: true,
            title: "EditCampaign",
          },
        },
      ],
    },
    {
      path: "/company-admin/billing",
      name: "company-admin-billing",
      redirect: { name: "company-admin-billing-invoices" },
      component: () => import("./views/CompanyAdmin/Billing/Index.vue"),
      meta: {
        is_company_admin: true,
        requires_auth: true,
        title: "Invoices",
      },
      children: [
        {
          path: "invoices",
          name: "company-admin-billing-invoices",
          component: () => import("./views/CompanyAdmin/Billing/Invoices.vue"),
          meta: {
            is_company_admin: true,
            requires_auth: true,
            title: "Billing",
          },
        },
        {
          path: "add-invoice",
          name: "company-admin-invoice-add",
          component: () =>
            import("./views/CompanyAdmin/Billing/AddInvoice.vue"),
          meta: {
            is_company_admin: true,
            requires_auth: true,
            title: "Add Invoice",
          },
        },
        {
          path: "payment",
          name: "company-admin-billing-payment",
          component: () => import("./views/CompanyAdmin/Billing/Payment.vue"),
          meta: {
            is_company_admin: true,
            requires_auth: true,
            title: "Billing",
          },
        },
        // {
        //   path: "add-payment",
        //   name: "company-admin-billing-add-payment",
        //   component: () =>
        //     import("./views/CompanyAdmin/Billing/AddPayment.vue"),
        //   meta: {
        //     is_company_admin: true,
        //     requires_auth: true,
        //     title: "Add Payment",
        //   },
        // },
      ],
    },
    {
      path: "/company-admin/sms-log",
      name: "company-admin-sms-log",
      redirect: { name: "company-admin-sms-log-list-incoming" },
      component: () => import("./views/CompanyAdmin/SmsLog/Index.vue"),
      meta: {
        is_company_admin: true,
        requires_auth: true,
        title: "SMS Log",
      },
      children: [
        {
          path: "incoming",
          name: "company-admin-sms-log-list-incoming",
          component: () => import("./views/CompanyAdmin/SmsLog/Incoming.vue"),
          meta: {
            is_company_admin: true,
            requires_auth: true,
            title: "SMS Log",
          },
        },
        {
          path: "outgoing",
          name: "company-admin-sms-log-list-outgoing",
          component: () => import("./views/CompanyAdmin/SmsLog/Outgoing.vue"),
          meta: {
            is_company_admin: true,
            requires_auth: true,
            title: "SMS Log",
          }
        }
      ],
    },
    {
      path: "/company-admin/dids",
      name: "company-admin-dids",
      redirect: { name: "company-admin-dids-all-did" },
      component: () => import("./views/CompanyAdmin/Dids/Index.vue"),
      meta: {
        is_company_admin: true,
        requires_auth: true,
        title: "DIDs",
      },
      children: [
        {
          path: "all-did",
          name: "company-admin-dids-all-did",
          component: () =>
            import("./views/CompanyAdmin/Dids/AllDids/AllDids.vue"),
          redirect: { name: "company-admin-dids-local-did" },
          meta: {
            is_company_admin: true,
            requires_auth: true,
            title: "Local DIDs",
          },
          children: [
            {
              path: "local-did",
              name: "company-admin-dids-local-did",
              component: () =>
                import("./views/CompanyAdmin/Dids/AllDids/LocalDids.vue"),
              meta: {
                is_company_admin: true,
                requires_auth: true,
                title: "Local DIDs",
              },
            },
            {
              path: "toll-free",
              name: "company-admin-dids-toll-free",
              component: () =>
                import("./views/CompanyAdmin/Dids/AllDids/TollFreeDids.vue"),
              meta: {
                is_company_admin: true,
                requires_auth: true,
                title: "Toll Free",
              },
            },
          ],
        },
        {
          path: "buy-did",
          name: "company-admin-dids-buy-did",
          component: () =>
            import("./views/CompanyAdmin/Dids/AllDids/BuyDid.vue"),
          meta: {
            is_company_admin: true,
            requires_auth: true,
            title: "Buy DID",
          },
        },
        {
          path: "buy-tf-did",
          name: "company-admin-dids-buy-tf-did",
          component: () =>
            import("./views/CompanyAdmin/Dids/AllDids/BuyTollFreeDid.vue"),
          meta: {
            is_company_admin: true,
            requires_auth: true,
            title: "Buy Toll Free DID",
          },
        },
        {
          path: "edit-did/:id",
          name: "company-admin-dids-edit-did",
          component: () => import("./views/CompanyAdmin/Dids/EditDid.vue"),
          meta: {
            is_company_admin: true,
            requires_auth: true,
            title: "Edit DID",
          },
        },
        // {
        //   path: "suppression",
        //   name: "company-admin-dids-suppression",
        //   component: () => import("./views/CompanyAdmin/Dids/Suppression.vue"),
        //   meta: {
        //     is_company_admin: true,
        //     requires_auth: true,
        //     title: "Suppression",
        //   },
        // },
      ],
    },
    // Company user
    {
      path: "/company-user",
      name: "company_user",
      redirect: { name: "company-user-sms-center" },
      component: () => import("./views/CompanyUser/SmsCenter/Index.vue"),
      meta: {
        is_company_user: true,
        requires_auth: true,
        title: 'Sms Center',
      },
      children: [
        {
          path: "sms-center",
          name: "company-user-sms-center",
          component: () => import("./views/CompanyUser/SmsCenter/Index.vue"),
          meta: {
            is_company_user: true,
            requires_auth: true,
            title: 'Sms Center',
          }
        },
      ]
    },
    {
      path: "/company-user/profile",
      name: "company-user-profile",
      component: () => import("./views/CompanyUser/Profile/Index.vue"),
      meta: {
        is_company_user: true,
        requires_auth: true,
        title: 'Profile',
      },
      children: [
        {
          path: "edit-company-info/:id",
          name: "company-user-profile-edit-company-info",
          component: () => import("./views/CompanyUser/Profile/EditCompanyInfo"),
          meta: {
            is_company_user: true,
            requires_auth: true,
            title: 'Edit User Company Info',
          }
        },
      ]
    },
    {
      path: "/company-user/sms-log",
      name: "company-user-sms-log",
      redirect: { name: "company-user-sms-log-list-incoming" },
      component: () => import("./views/CompanyUser/SmsLog/Index.vue"),
      meta: {
        is_company_user: true,
        requires_auth: true,
        title: 'SMS Log',
      },
      children: [
        // {
        //   path: "sms-log-list",
        //   name: "company-user-sms-log-list",
        //   component: () => import("./views/CompanyUser/SmsLog/SmsLogList.vue"),
        //   meta: {
        //     is_company_user: true,
        //     requires_auth: true,
        //     title: 'SMS Log',
        //   },
        // },
        {
          path: "incoming",
          name: "company-user-sms-log-list-incoming",
          component: () => import("./views/CompanyUser/SmsLog/Incoming.vue"),
          meta: {
            is_company_user: true,
            requires_auth: true,
            title: "SMS Log",
          },
        },
        {
          path: "outgoing",
          name: "company-user-sms-log-list-outgoing",
          component: () => import("./views/CompanyUser/SmsLog/Outgoing.vue"),
          meta: {
            is_company_user: true,
            requires_auth: true,
            title: "SMS Log",
          },
        },
      ]
    },
    {
      path: "/company-user",
      name: "company_user",
      redirect: { name: "company-user-dids" },
      component: () => import("./views/CompanyUser/Dids/Index.vue"),
      meta: {
        is_company_user: true,
        requires_auth: true,
        title: "Dids",
      },
      children: [
        {
          path: "dids",
          name: "company-user-dids",
          //   component: () => import("./views/CompanyUser/Dids/Index.vue"),
          meta: {
            is_company_user: true,
            requires_auth: true,
            title: "Dids",
          },
        },
      ],
    },
    {
      path: "/company-user",
      name: "company_user",
      redirect: { name: "company-user-sms-workflow" },
      component: () => import("./views/CompanyUser/SmsWorkflow/Index.vue"),
      meta: {
        is_company_user: true,
        requires_auth: true,
        title: "Sms Workflow",
      },
      children: [
        {
          path: "sms-workflow",
          name: "company-user-sms-workflow",
          //   component: () => import("./views/CompanyUser/SmsCenter/Index.vue"),
          meta: {
            is_company_user: true,
            requires_auth: true,
            title: "Sms Workflow",
          },
        },
      ],
    },
    {
      path: "/company-user/reminder-workflow",
      name: "company-user-reminder-workflow",
      redirect: { name: "company-user-reminder-workflow-list" },
      component: () => import("./views/CompanyUser/ReminderWorkflow/Index.vue"),
      meta: {
        is_company_user: true,
        requires_auth: true,
        title: "Reminder Workflow",
      },
      children: [
        {
          path: "reminder-workflow-list",
          name: "company-user-reminder-workflow-list",
          component: () =>
            import("./views/CompanyUser/ReminderWorkflow/ReminderWorkflowList.vue"),
          meta: {
            is_company_user: true,
            requires_auth: true,
            title: "Reminder Workflow",
          },
        },
        {
          path: "add-reminder-workflow",
          name: "company-user-add-reminder-workflow",
          component: () =>
            import("./views/CompanyUser/ReminderWorkflow/AddReminderWorkflow.vue"),
          meta: {
            is_company_user: true,
            requires_auth: true,
            title: "Reminder Workflow",
          },
        },
        {
          path: "edit-reminder-workflow",
          name: "company-admin-edit-reminder-workflow",
          component: () =>
            import("./views/CompanyUser/ReminderWorkflow/EditReminderWorkflow.vue"),
          meta: {
            is_company_user: true,
            requires_auth: true,
            title: "Reminder Workflow",
          },
        },
      ],
    },

    {
      path: "/reseller/vendor",
      name: "reseller-vendor",
      redirect: { name: "reseller-vendors-list" },
      component: () => import("./views/Reseller/Vendors/Index.vue"),
      meta: {
        is_reseller: true,
        requires_auth: true,
        title: "Vendors",
      },
      children: [
        {
          path: "vendors-list",
          name: "reseller-vendors-list",
          component: () => import("./views/Reseller/Vendors/VendorList.vue"),
          meta: {
            is_reseller: true,
            requires_auth: true,
            title: "Vendors",
          },
        },
        {
          path: "add-vendor",
          name: "reseller-vendor-add",
          component: () => import("./views/Reseller/Vendors/AddVendor.vue"),
          meta: {
            is_reseller: true,
            requires_auth: true,
            title: "Add Vendor",
          },
        },
        {
          path: "edit-vendor/:id",
          name: "reseller-vendor-edit",
          component: () => import("./views/Reseller/Vendors/EditVendor.vue"),
          meta: {
            is_reseller: true,
            requires_auth: true,
            title: "Edit Vendor",
          },
        },
      ],
    },
    {
      path: "/reseller/users",
      name: "reseller-users",
      redirect: { name: "reseller-users-list" },
      component: () => import("./views/Reseller/Users/Index.vue"),
      meta: {
        is_reseller: true,
        requires_auth: true,
        title: "Users",
      },
      children: [
        {
          path: "users-list",
          name: "reseller-users-list",
          component: () => import("./views/Reseller/Users/UsersList.vue"),
          meta: {
            is_reseller: true,
            requires_auth: true,
            title: "Users",
          },
        },
        {
          path: "add",
          name: "reseller-user-add",
          component: () => import("./views/Reseller/Users/AddUser.vue"),
          meta: {
            is_reseller: true,
            requires_auth: true,
            title: "Add User",
          },
        },
        {
          path: "edit/:id",
          name: "reseller-user-edit",
          component: () => import("./views/Reseller/Users/EditUser.vue"),
          meta: {
            is_reseller: true,
            requires_auth: true,
            title: "Edit User",
          },
        },
      ],
    },
    {
      path: "/reseller/companies",
      name: "reseller-companies",
      component: () => import("./views/Reseller/Companies/Index.vue"),
      redirect: { name: "reseller-company-list" },
      meta: {
        is_reseller: true,
        requires_auth: true,
        title: "Companies",
      },
      children: [
        {
          path: "company-list",
          name: "reseller-company-list",
          component: () => import("./views/Reseller/Companies/CompanyList.vue"),
          meta: {
            is_reseller: true,
            requires_auth: true,
            title: "Companies",
          },
        },
        {
          path: "add-company",
          name: "reseller-add-company",
          component: () => import("./views/Reseller/Companies/AddCompany.vue"),
          meta: {
            is_reseller: true,
            requires_auth: true,
            title: "Add Company",
          },
        },
        {
          path: "edit-company/:id",
          name: "reseller-edit-company",
          component: () => import("./views/Reseller/Companies/EditCompany.vue"),
          meta: {
            is_reseller: true,
            requires_auth: true,
            title: "Edit Company",
          },
        },
        {
          path: ":id/invoice-history",
          name: "reseller-companies-invoice-history",
          component: () =>
            import("./views/Reseller/Companies/HistoryPages/InvoiceHistory.vue"),
          meta: {
            is_reseller: true,
            requires_auth: true,
            title: "Company Invoice History",
          },
        },
        {
          path: ":id/payment-history",
          name: "reseller-companies-payment-history",
          component: () =>
            import("./views/Reseller/Companies/HistoryPages/PaymentHistory.vue"),
          meta: {
            is_reseller: true,
            requires_auth: true,
            title: "Company Payment History",
          },
        },
        {
          path: "transaction-history",
          name: "reseller-companies-transaction-history",
          component: () =>
            import("./views/Reseller/Companies/HistoryPages/TransactionHistory.vue"),
          meta: {
            is_reseller: true,
            requires_auth: true,
            title: "Company Transaction History",
          },
        },
        {
          path: "add-manual-payment",
          name: "reseller-companies-add-manual-payment",
          component: () =>
            import("./views/Reseller/Companies/HistoryPages/AddManualPayment.vue"),
          meta: {
            is_reseller: true,
            requires_auth: true,
            title: "Company AddManual Payment",
          },
        },
      ],
    },
    {
      path: "add-manual-payment",
      name: "reseller-companies-add-manual-payment",
      component: () =>
        import("./views/Reseller/Companies/HistoryPages/AddManualPayment.vue"),
      meta: {
        is_reseller: true,
        requires_auth: true,
        title: "Company AddManual Payment",
      },
    },
    {
      path: "reseller-sms-center",
      name: "reseller-sms-center",
      component: () =>
        import("./views/Reseller/SmsCenter/SmsCenter.vue"),
      meta: {
        is_reseller: true,
        requires_auth: true,
        title: "Sms Center",
      },
    },
    {
      path: "reseller-sms-log",
      name: "reseller-sms-log",
      component: () =>
        import("./views/Reseller/SmsLog/SmsLogList.vue"),
      meta: {
        is_reseller: true,
        requires_auth: true,
        title: "SMS Log",
      },
    },
    {
      path: "/reseller/billing",
      name: "reseller-billing",
      redirect: { name: "reseller-billing-invoices" },
      component: () => import("./views/Reseller/Billing/Index.vue"),
      meta: {
        is_reseller: true,
        requires_auth: true,
        title: "Invoices",
      },
      children: [
        {
          path: "invoices",
          name: "reseller-billing-invoices",
          component: () => import("./views/Reseller/Billing/Invoices.vue"),
          meta: {
            is_reseller: true,
            requires_auth: true,
            title: "Billing",
          },
        },
        {
          path: "add-invoice",
          name: "reseller-invoice-add",
          component: () => import("./views/Reseller/Billing/AddInvoice.vue"),
          meta: {
            is_reseller: true,
            requires_auth: true,
            title: "Add Invoice",
          },
        },
        {
          path: "payment",
          name: "reseller-billing-payment",
          component: () => import("./views/Reseller/Billing/Payment.vue"),
          meta: {
            is_reseller: true,
            requires_auth: true,
            title: "Billing",
          },
        },
        {
          path: "add-payment",
          name: "reseller-billing-add-payment",
          component: () => import("./views/Reseller/Billing/AddPayment.vue"),
          meta: {
            is_reseller: true,
            requires_auth: true,
            title: "Add Payment",
          },
        },
      ],
    },
    {
      path: "/reseller/filters",
      name: "reseller-filters",
      redirect: { name: "reseller-filter-list" },
      component: () => import("./views/Reseller/Filters/Index.vue"),
      meta: {
        is_reseller: true,
        requires_auth: true,
        title: "Filters",
      },
      children: [
        {
          path: "filter-list",
          name: "reseller-filter-list",
          component: () => import("./views/Reseller/Filters/FilterList.vue"),
          meta: {
            is_reseller: true,
            requires_auth: true,
            title: "Filters",
          },
        },
        {
          path: "add-filter",
          name: "reseller-filter-add",
          component: () => import("./views/Reseller/Filters/AddFilter.vue"),
          meta: {
            is_reseller: true,
            requires_auth: true,
            title: "Add Filter",
          },
        },
        {
          path: "edit-filter/:id",
          name: "reseller-filter-edit",
          component: () => import("./views/Reseller/Filters/EditFilter.vue"),
          meta: {
            is_reseller: true,
            requires_auth: true,
            title: "Edit Filter",
          },
        },
      ],
    },
    {
      path: "/reseller/product",
      name: "reseller-product",
      component: () => import("./views/Reseller/Products/Index.vue"),
      redirect: { name: "reseller-sms-routes" },
      meta: {
        is_reseller: true,
        requires_auth: true,
        title: "Products",
      },
      children: [
        {
          path: "sms-routes",
          name: "reseller-sms-routes",
          component: () => import("./views/Reseller/Products/ProductList.vue"),
          meta: {
            is_reseller: true,
            requires_auth: true,
            title: "Products",
          },
        },
        {
          path: "sms-routes/add-product",
          name: "reseller-add-route-product",
          component: () =>
            import("./views/Reseller/Products/AddProduct/Index.vue"),
          meta: {
            is_reseller: true,
            requires_auth: true,
            title: "Add Product",
          },
        },
        {
          path: "sms-routes/edit-product/:id",
          name: "reseller-edit-route-product",
          component: () =>
            import("./views/Reseller/Products/EditProduct/Index.vue"),
          meta: {
            is_reseller: true,
            requires_auth: true,
            title: "Edit Product",
          },
        },
        // {
        //   path: "sms-pricing",
        //   name: "reseller-sms-pricing",
        //   component: () =>
        //     import("./views/Reseller/Products/ProductList.vue"),
        //   meta: {
        //     is_reseller: true,
        //     requires_auth: true
        //   }
        // },
      ],
    },
    {
      path: "/reseller",
      name: "reseller",
      component: () => import("./views/Reseller/Profile/Index.vue"),
      redirect: { name: "reseller-payment-gateway" },
      meta: {
        is_reseller: true,
        requires_auth: true,
        title: "Profile",
      },
      children: [
        // {
        //   path: "portal/customization",
        //   name: "reseller-portal-customization",
        //   component: () =>
        //     import("./views/Reseller/Profile/PortalCustomization.vue"),
        //   meta: {
        //     is_reseller: true,
        //     requires_auth: true
        //   }
        // },
        {
          path: "payment/gateway",
          name: "reseller-payment-gateway",
          component: () =>
            import("./views/Reseller/Profile/PaymentGateway.vue"),
          meta: {
            is_reseller: true,
            requires_auth: true,
            title: "Payment Geteway",
          },
        },
      ],
    },
    {
      path: "/reseller/user",
      name: "reseller-user",
      component: () => import("./views/Reseller/UserListing/Index.vue"),
      redirect: { name: "reseller-user" },
      meta: {
        is_reseller: true,
        requires_auth: true,
        title: "User Listing",
      },
      children: [
        {
          path: "user-listing",
          name: "reseller-user-listing",
          component: () =>
            import("./views/Reseller/UserListing/UserListing.vue"),
          meta: {
            is_reseller: true,
            requires_auth: true,
            title: "User Listing",
          },
        },
      ],
    },
    {
      path: "/reseller/mail-template",
      name: "reseller-mail-template",
      component: () => import("./views/Reseller/MailTemplate/Index.vue"),
      redirect: { name: "reseller-mail-template-template" },
      meta: {
        is_reseller: true,
        requires_auth: true,
        title: "Mail Template",
      },
      children: [
        {
          path: "registration",
          name: "reseller-mail-template-registration",
          component: () =>
            import("./views/Reseller/MailTemplate/Registration.vue"),
          meta: {
            is_reseller: true,
            requires_auth: true,
            title: "Mail Template Registration",
          },
        },
        {
          path: "template",
          name: "reseller-mail-template-template",
          component: () =>
            import("./views/Reseller/MailTemplate/MailTemplate.vue"),
          meta: {
            is_reseller: true,
            requires_auth: true,
            title: "Mail Template",
          },
        },
      ],
    },
    {
      path: "/reseller/dids",
      name: "reseller-dids",
      redirect: { name: "reseller-dids-all-dids" },
      component: () => import("./views/Reseller/Dids/Index.vue"),
      meta: {
        is_reseller: true,
        requires_auth: true,
        title: "DIDs",
      },
      children: [
        {
          path: "all-dids",
          name: "reseller-dids-all-dids",
          component: () => import("./views/Reseller/Dids/AllDids.vue"),
          meta: {
            is_reseller: true,
            requires_auth: true,
            title: "DIDs",
          },
        },
        {
          path: "add-did",
          name: "reseller-dids-add-did",
          component: () => import("./views/Reseller/Dids/AddDid.vue"),
          meta: {
            is_reseller: true,
            requires_auth: true,
            title: "Add DID",
          },
        },
        {
          path: "import-did",
          name: "reseller-dids-import-did",
          component: () => import("./views/Reseller/Dids/ImportDid.vue"),
          meta: {
            is_reseller: true,
            requires_auth: true,
            title: "Import DID",
          },
        },
        {
          path: "edit-did/:id",
          name: "reseller-dids-edit-did",
          component: () => import("./views/Reseller/Dids/EditDid.vue"),
          meta: {
            is_reseller: true,
            requires_auth: true,
            title: "Edit DID",
          },
        },
      ],
    },
    {
      path: "/reseller/template-approval",
      name: "reseller-template-approval",
      redirect: { name: "reseller-template-approval-list" },
      component: () => import("./views/Reseller/TemplateApproval/Index.vue"),
      meta: {
        is_reseller: true,
        requires_auth: true,
        title: "Template Approval",
      },
      children: [
        {
          path: "template-approval-list",
          name: "reseller-template-approval-list",
          component: () =>
            import("./views/Reseller/TemplateApproval/TemplateApproval.vue"),
          meta: {
            is_reseller: true,
            requires_auth: true,
            title: "Template Approval",
          },
        },
        {
          path: "add-template",
          name: "reseller-template-approval-add",
          component: () =>
            import("./views/Reseller/TemplateApproval/AddTemplateApproval.vue"),
          meta: {
            is_reseller: true,
            requires_auth: true,
            title: "Add Template Approval",
          },
        },
        {
          path: "edit/:id",
          name: "reseller-template-approval-edit",
          component: () =>
            import("./views/Reseller/TemplateApproval/EditTemplate.vue"),
          meta: {
            is_reseller: true,
            requires_auth: true,
            title: "Edit Template Approval",
          },
        },
      ],
    },
    {
      path: "*",
      redirect: { name: "company_admin" },
      meta: {
        requires_auth: true,
      },
    },
  ],
});
router.beforeEach((to, from, next) => {
  if (to.matched.some((record) => record.meta.requires_auth)) {
    if (!store.getters.isAuthenticated) {
      next({
        path: "/login",
        params: { nextUrl: to.fullPath },
      });
    } else {
      const nearestWithTitle = to.matched
        .slice()
        .reverse()
        .find((r) => r.meta && r.meta.title);
      store.commit("setPageHeader", nearestWithTitle.meta.title);

      if (to.matched.some((record) => record.meta.is_company_admin)) {
        if (store.state.auth.user_type === "company_admin") {
          next();
        } else {
          next({
            name: store.state.auth.user_type,
          });
        }
      }
      else if (to.matched.some((record) => record.meta.is_system_admin)) {
        if (store.state.auth.user_type === "admin") {
          next();
        } else {
          next({
            name: store.state.auth.user_type,
          });
        }
      } else if (to.matched.some((record) => record.meta.is_company_user)) {
        if (store.state.auth.user_type === "user") {
          next();
        } else {
          next({
            name: store.state.auth.user_type,
          });
        }
      } else if (to.matched.some((record) => record.meta.is_reseller)) {
        if (store.state.auth.user_type === "reseller") {
          next();
        } else {
          next({
            name: store.state.auth.user_type,
          });
        }
      } else {
        next();
      }
    }
  } else {
    next();
  }
});
export default router;
